const PREFIX = "pl-bill-details-renderer";

export const PL_BILL_DETAILS_RENDERER_TEST_IDS = {
    CONTAINER: `${PREFIX}-container`,
};
